import { ArrayDataSource } from './BaseDataSources';
import { IProductReviewType, IReviewProduct } from '../Interfaces';

export class ReviewProductSource extends ArrayDataSource<IProductReviewType> {
  public constructor(rid: string, vid: string) {
    super('/datasource/reviewproducts', { rid, vid });
  }
}

export class ReviewProductByReviewTypeSource extends ArrayDataSource<IReviewProduct> {
  public constructor(rid: string) {
    super('/datasource/reviewproductsbyreview', { rid });
  }
}